export const BANKS = {
  BS2: '218',
  BTG: '208',
};
